import _extends from 'babel-runtime/helpers/extends';
import _regeneratorRuntime from 'babel-runtime/regenerator';

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(flushIndexedDb),
    _marked2 = /*#__PURE__*/_regeneratorRuntime.mark(assimilateProgressMPError),
    _marked3 = /*#__PURE__*/_regeneratorRuntime.mark(loadingMpProgressLibraryStateChange),
    _marked4 = /*#__PURE__*/_regeneratorRuntime.mark(loadUpToDateCourseProgress),
    _marked5 = /*#__PURE__*/_regeneratorRuntime.mark(removeSequenceProgressSaga),
    _marked6 = /*#__PURE__*/_regeneratorRuntime.mark(DEV_getProgressFromServerAndVerifyLocalCalculation),
    _marked7 = /*#__PURE__*/_regeneratorRuntime.mark(handleProgressAddedSaga),
    _marked8 = /*#__PURE__*/_regeneratorRuntime.mark(progressSagas);

import { call, delay, put, select, takeEvery, takeLatest } from 'redux-saga/effects';
import { startInteraction, logSegment, endInteraction } from '@rosetta/eve-client';
import { stepStatusActions, stepStatusSelectors } from '../../step-status/redux/step-status-reducer';
import { kotlinListToJsArray, kotlinLongToDate } from '../dekotlinizer';
import { ProgressQuery } from '../apollo/progress-graphql';
import { addStepAttemptToProgress, compareProgressObjects } from '../progress-services';
import { FLUSH_INDEXED_DB, PROGRESS_MP_ERROR_RECEIVED, LOAD_PROGRESS, FETCH_LAST_SEQUENCE_ATTEMPTED, LOADING_MP_PROGRESS_LIBRARY, REMOVE_SEQUENCE_PROGRESS, progressActions, progressSelectors, HANDLE_PROGRESS_ADDED } from './progress-reducer';
import { getGaiaApolloClient, getErrorHandler, getLogger, getCourseSelectors } from '../../init';
import progressManagerHelper from '../progress-manager-helper';

function flushIndexedDb() {
  return _regeneratorRuntime.wrap(function flushIndexedDb$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt('return', progressManagerHelper.flushIndexedDb());

        case 1:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

// Provide Redux entry point for async erros coming from Progress-MP.
function assimilateProgressMPError(_ref) {
  var _ref$payload = _ref.payload,
      context = _ref$payload.context,
      throwable = _ref$payload.throwable;
  var stepStatusContext;
  return _regeneratorRuntime.wrap(function assimilateProgressMPError$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return select(stepStatusSelectors.getStepStatusContext);

        case 2:
          stepStatusContext = _context2.sent;
          _context2.next = 5;
          return call(getErrorHandler(), {
            message: context + ': ' + throwable.toString(),
            params: stepStatusContext
          });

        case 5:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

// Catch the point when Progress-MP Library has finished initializing to do pending work.
function loadingMpProgressLibraryStateChange(_ref2) {
  var loadingMPProgressLibrary = _ref2.payload.loadingMPProgressLibrary;
  var delayedProgressFetchCourseId;
  return _regeneratorRuntime.wrap(function loadingMpProgressLibraryStateChange$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          if (loadingMPProgressLibrary) {
            _context3.next = 7;
            break;
          }

          _context3.next = 3;
          return select(progressSelectors.getDelayedProgressFetchCourseId);

        case 3:
          delayedProgressFetchCourseId = _context3.sent;

          if (!delayedProgressFetchCourseId) {
            _context3.next = 7;
            break;
          }

          _context3.next = 7;
          return put(progressActions.loadProgress(delayedProgressFetchCourseId));

        case 7:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

// Invoked when course switched/loaded.
function loadUpToDateCourseProgress(_ref3) {
  var courseId = _ref3.payload.courseId;
  var loadingMPProgressLibrary, progressResponse, courseProgress, assignedCourse;
  return _regeneratorRuntime.wrap(function loadUpToDateCourseProgress$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          if (courseId) {
            _context4.next = 4;
            break;
          }

          _context4.next = 3;
          return call(getErrorHandler(), { message: 'courseId not provided for loading course progress' });

        case 3:
          return _context4.abrupt('return', _context4.sent);

        case 4:
          startInteraction('loadUpToDateCourseProgress'); // eve intrumentation
          _context4.prev = 5;
          _context4.next = 8;
          return select(progressSelectors.getLoadingMPProgressLibrary);

        case 8:
          loadingMPProgressLibrary = _context4.sent;

          if (!loadingMPProgressLibrary) {
            _context4.next = 13;
            break;
          }

          _context4.next = 12;
          return put(progressActions.setDelayedProgressFetchCourseId(courseId));

        case 12:
          return _context4.abrupt('return');

        case 13:
          _context4.next = 15;
          return put(progressActions.setDelayedProgressFetchCourseId(null));

        case 15:
          _context4.next = 17;
          return put(stepStatusActions.courseViewed(courseId));

        case 17:

          logSegment('loadUpToDateCourseProgress', 'service-call'); // eve intrumentation
          // pull progress from gaia-server
          _context4.next = 20;
          return call(getGaiaApolloClient().query, {
            query: ProgressQuery,
            fetchPolicy: 'no-cache',
            variables: { courseId: courseId }
          });

        case 20:
          progressResponse = _context4.sent;

          if (progressResponse.data.progress) {
            _context4.next = 25;
            break;
          }

          _context4.next = 24;
          return call(getErrorHandler(), { message: 'progress data not available for course ' + courseId });

        case 24:
          return _context4.abrupt('return', _context4.sent);

        case 25:
          courseProgress = void 0;

          if (!(progressResponse.data.progress.length === 0)) {
            _context4.next = 33;
            break;
          }

          _context4.next = 29;
          return select(getCourseSelectors().getAssignedCourse, courseId);

        case 29:
          assignedCourse = _context4.sent;

          courseProgress = {
            courseId: courseId,
            countOfSequencesInCourse: assignedCourse && assignedCourse.sequences ? assignedCourse.sequences.length : 0,
            id: courseId,
            sequences: []
          };
          _context4.next = 34;
          break;

        case 33:
          courseProgress = progressResponse.data.progress[0];

        case 34:
          _context4.next = 36;
          return put(progressActions.setCurrentCourseProgress(courseProgress));

        case 36:
          logSegment('loadUpToDateCourseProgress', 'push-to-redux-' + progressResponse.data.progress.length); // eve instrumentation

        case 37:
          _context4.prev = 37;

          endInteraction('loadUpToDateCourseProgress'); // eve instrumentation
          return _context4.finish(37);

        case 40:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this, [[5,, 37, 40]]);
}

function fetchLastSequenceAttempted(_ref4) {
  var courseId = _ref4.payload.courseId;

  progressManagerHelper.fetchLastSequenceAttempted(courseId);
}

function removeSequenceProgressSaga(_ref5) {
  var payload = _ref5.payload;
  return _regeneratorRuntime.wrap(function removeSequenceProgressSaga$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          if (!(!payload.courseId || !payload.sequenceId || !payload.sequenceVersion)) {
            _context5.next = 4;
            break;
          }

          _context5.next = 3;
          return call(getErrorHandler(), { message: 'missing args for removeSequenceProgress' });

        case 3:
          return _context5.abrupt('return', _context5.sent);

        case 4:
          progressManagerHelper.removeSequenceProgressFromDb(payload.courseId, payload.sequenceId, payload.sequenceVersion);

        case 5:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked5, this);
}

// development-only thing
function DEV_getProgressFromServerAndVerifyLocalCalculation(courseId, locallyCalculatedProgress) {
  var progressResponse, noDiff;
  return _regeneratorRuntime.wrap(function DEV_getProgressFromServerAndVerifyLocalCalculation$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return call(getGaiaApolloClient().query, {
            query: ProgressQuery,
            fetchPolicy: 'no-cache',
            variables: { courseId: courseId }
          });

        case 2:
          progressResponse = _context6.sent;
          _context6.next = 5;
          return compareProgressObjects(locallyCalculatedProgress, progressResponse.data.progress[0]);

        case 5:
          noDiff = _context6.sent;

          if (!noDiff) {
            getLogger().error('progress mismatch errors found!!');
          }

        case 7:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked6, this);
}

function handleProgressAddedSaga(_ref6) {
  var payload = _ref6.payload;
  var progressAdded, beforeProgress, assignedCourseInfo, newProgress;
  return _regeneratorRuntime.wrap(function handleProgressAddedSaga$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          progressAdded = _extends({}, payload.progressAdded);

          progressAdded.answers = kotlinListToJsArray(progressAdded.answers);
          progressAdded.endTimestamp = kotlinLongToDate(progressAdded.endTimestamp);
          // get current progress state
          _context7.next = 5;
          return select(progressSelectors.getCurrentCourseProgress);

        case 5:
          beforeProgress = _context7.sent;

          if (!beforeProgress) {
            _context7.next = 15;
            break;
          }

          _context7.next = 9;
          return select(getCourseSelectors().getAssignedCourse, beforeProgress.courseId);

        case 9:
          assignedCourseInfo = _context7.sent;
          _context7.next = 12;
          return addStepAttemptToProgress(progressAdded, beforeProgress, assignedCourseInfo);

        case 12:
          newProgress = _context7.sent;
          _context7.next = 15;
          return put(progressActions.setCurrentCourseProgress(newProgress));

        case 15:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked7, this);
}

export function progressSagas() {
  return _regeneratorRuntime.wrap(function progressSagas$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return takeEvery(HANDLE_PROGRESS_ADDED, handleProgressAddedSaga);

        case 2:
          _context8.next = 4;
          return takeEvery(FLUSH_INDEXED_DB, flushIndexedDb);

        case 4:
          _context8.next = 6;
          return takeEvery(PROGRESS_MP_ERROR_RECEIVED, assimilateProgressMPError);

        case 6:
          _context8.next = 8;
          return takeLatest(LOAD_PROGRESS, loadUpToDateCourseProgress);

        case 8:
          _context8.next = 10;
          return takeLatest(FETCH_LAST_SEQUENCE_ATTEMPTED, fetchLastSequenceAttempted);

        case 10:
          _context8.next = 12;
          return takeEvery(LOADING_MP_PROGRESS_LIBRARY, loadingMpProgressLibraryStateChange);

        case 12:
          _context8.next = 14;
          return takeLatest(REMOVE_SEQUENCE_PROGRESS, removeSequenceProgressSaga);

        case 14:
        case 'end':
          return _context8.stop();
      }
    }
  }, _marked8, this);
}